import { array } from 'fp-ts';
import { createFormResolver } from '@mews-commander/form';
import { validation as validate } from '@mews-commander/legacy-form';
import { FormErrors, WithEnterpriseIds, WithVoucherIds } from '../../../../types';
import { VoucherDialogForm } from './VoucherDialogForm';
import { getConstraints } from './constraints';
import { FieldName, FormValues, WithFieldsConfig } from './types';

type VoucherContainerProps = Omit<
    React.ComponentPropsWithoutRef<typeof VoucherDialogForm>,
    'useFormProps' | 'onSubmit'
> &
    WithEnterpriseIds &
    WithVoucherIds &
    WithFieldsConfig & {
        onSubmit: (formValues: FormValues) => void;
        values?: FormValues;
        selectedVouchersCount?: number;
        formErrors?: FormErrors;
        unlockField?: (fieldName: FieldName) => void;
        unlockedFields?: FieldName[];
        isCreatingFromRates?: boolean;
    };

export const DEFAULT_VALUES: FormValues = {
    companyKey: '',
    name: '',
    key: '',
    rateKeys: [],
};

export const VoucherContainer = ({
    fieldsConfig,
    values,
    onSubmit,
    enterpriseIds,
    voucherIds,
    formErrors,
    unlockedFields,
    isCreatingFromRates,
    ...other
}: VoucherContainerProps) => {
    const isCreateForm = !voucherIds || array.isEmpty(voucherIds);

    const constraints = getConstraints({
        enabledFields: fieldsConfig?.enabledFields,
        isCreateForm,
        unlockedFields,
        isCreatingFromRates,
    });

    const resolver = createFormResolver<FormValues>(validate(constraints));

    const formProps = {
        resolver,
        defaultValues: DEFAULT_VALUES,
        values,
    };

    return (
        <VoucherDialogForm
            formErrors={formErrors}
            useFormProps={formProps}
            onSubmit={onSubmit}
            fieldsConfig={fieldsConfig}
            enterpriseIds={enterpriseIds}
            voucherIds={voucherIds}
            isCreatingFromRates={isCreatingFromRates}
            {...other}
        />
    );
};
